import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SimpleStack } from '../Moonstar/SimpleStack';

export const DepartmentCreate = () => (
  <MoonstarCreate redirect="list">
    <MoonstarCreateForm>
      <SimpleStack>
        <TextInput source="name" validate={required()} />
      </SimpleStack>
    </MoonstarCreateForm>
  </MoonstarCreate>
);
